'use strict';

import './WhatsIncludedCarousel.less';

import React from 'react';
import lang from './WhatsIncludedCarouselLang';
import ReactCKImage from 'ck-core-client/source/ui/ReactCKImage';
import PropTypes from 'prop-types';

export default class WhatsIncludedCarousel extends React.Component {
	constructor(props) {
		super(props);

		this.slidesLang = lang.SLIDES[this.props.langKey];
	}

	render() {
		return (
			<div className="WhatsIncludedCarousel">
				<ReactCKImage
					name="generic-grey-cloud"
					forceImgTag={true}
					extraClasses={['WhatsIncludedSlide__cloudLeft']}
				/>
				<ReactCKImage
					name="generic-grey-cloud"
					forceImgTag={true}
					extraClasses={['WhatsIncludedSlide__cloudRight']}
				/>
				<h2 className="WhatsIncludedCarousel__title">{lang.TITLE}</h2>
				<div className="WhatsIncludedCarousel__flex">
					{this.slidesLang.map(slideLang => {
						return (
							<div key={slideLang.BACKGROUND} className="WhatsIncludedSlide">
								<div className="WhatsIncludedSlide__image">
									<ReactCKImage
										name={slideLang.IMAGE}
										extraClasses={['WhatsIncludedSlide__image-src img-responsive']}
									/>
								</div>
								<div className="WhatsIncludedSlide__content">
									<h3 className="WhatsIncludedSlide__title">{slideLang.TITLE}</h3>
									<h4 className="WhatsIncludedSlide__text">{slideLang.TEXT}</h4>
								</div>
							</div>
						);
					})}
				</div>
			</div>
		);
	}
}

WhatsIncludedCarousel.propTypes = {
	langKey: PropTypes.string.isRequired
};
